import React from 'react';
import { Navigate } from 'react-router-dom';
import { useToken } from '@/stores/authStore';

const PublicRoute = ({ children }) => {
  const token = useToken();
  
  if (token) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default PublicRoute;